import {
  HorizontalAlignment,
  VerticalAlignment,
} from '@thg-commerce/enterprise-core'
import { mq, spacing, styled, Text } from '@thg-commerce/enterprise-theme'
import { Button } from '@thg-commerce/gravity-elements'
import { Grid, GridItem } from '@thg-commerce/gravity-system'

export const Container = styled.div<{
  horizontalAlignment?: HorizontalAlignment
}>`
  text-align: ${(props) => props.horizontalAlignment || 'left'};
  width: 100%;
  max-width: ${(props) => props.theme.site.siteWidth};
  margin: 0 auto;
  padding: ${spacing(1)} ${spacing(2)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding: ${spacing(2)} ${spacing(4)};
  }
`

export const ImageCollectionWrapper = styled(Grid)`
  margin-right: -${spacing(1)};
  margin-left: -${spacing(1)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-right: -${spacing(2)};
    margin-left: -${spacing(2)};
  }
`
export const ItemContainer = styled(Grid)`
  margin: 0;
  height: 100%;
`

export const StyledGrid = styled(Grid)`
  margin: 0;
`

export const StyledGridItem = styled(GridItem)`
  margin: 0;
`

export const ImageOverlayGridItem = styled(GridItem)`
  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    display: flex;
    margin-bottom: ${spacing(4)};
  }
`
export const StyledImage = styled.img`
  width: 100%;
  height: ${(props) => props.theme.widget.imageCollectionOverlay.image.height};
`
export const ImageOverlayTitle = styled.h3<{
  centerText?: boolean
  lightText?: boolean
}>`
  ${(props) =>
    Text(
      props.theme.widget.imageCollectionOverlay.title.font?.entry || 'medium1',
      props.theme.widget.imageCollectionOverlay.title.font?.style ||
        'alternate',
    )};
  margin-bottom: ${spacing(1)};
  ${(props) => props.centerText && 'text-align: center'}
  ${(props) =>
    props.lightText && `color: ${props.theme.colors.palette.greys.white}`}
`
export const ImageOverlaySubtitle = styled.p<{
  lightText?: boolean
  removeMargin?: boolean
}>`
  ${Text('bodyText', 'default')};
  margin-bottom: ${spacing(2)};
  ${(props) => props.removeMargin && `margin-bottom: 0;`}
  ${(props) =>
    props.lightText && `color: ${props.theme.colors.palette.greys.white}`}
`
export const ImageOverlayLink = styled(Button)`
  text-decoration: none;
  width: fit-content;
  color: ${(props) => props.theme.colors.palette.brand.base};
`

export const Title = styled.h2<{
  lightText?: boolean
}>`
  ${Text('large1', 'alternate')}
  margin-bottom: ${spacing(1)};
  text-align: inherit;
  ${(props) =>
    props.lightText && `color: ${props.theme.colors.palette.greys.white}`}
`

export const Subtitle = styled.p<{
  lightText?: boolean
  centerText?: boolean
}>`
  ${Text('bodyText', 'default')};
  margin-bottom: ${spacing(3)};
  text-align: inherit;
  ${(props) =>
    props.lightText && `color: ${props.theme.colors.palette.greys.white}`}
`

export const TextContainer = styled(GridItem)<{
  verticalAlignment?: VerticalAlignment
  removePointerEvents?: boolean
}>`
  display: flex;
  align-items: ${(props) =>
    props.verticalAlignment === 'top'
      ? 'flex-start'
      : props.verticalAlignment === 'middle'
      ? 'center'
      : 'flex-end'};

  width: 100%;
  padding: ${spacing(2)};
  margin: 0;

  ${(props) => props.removePointerEvents && 'pointer-events: none;'}

  ${(props) => mq(props.theme.breakpointUtils.map, 'xs')} {
    width: 100%;
    padding: 
      ${(props) =>
        props.theme.widget.imageCollectionOverlay.text?.padding.xs
          ? `${spacing(
              props.theme.widget.imageCollectionOverlay.text?.padding.xs,
            )} ${spacing(2)} 0 ${spacing(2)};`
          : spacing(2)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin: ${spacing(2)} 0;
    padding: 0
      ${(props) =>
        spacing(
          props.theme.widget.imageCollectionOverlay.text?.padding.sm || 2,
        )};
  }
  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin: ${spacing(4)} auto;
    padding: 0
      ${(props) =>
        spacing(
          props.theme.widget.imageCollectionOverlay.text?.padding.md || 4,
        )};
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'lg')} {
    padding: 0
      ${(props) =>
        spacing(
          props.theme.widget.imageCollectionOverlay.text?.padding.lg || 4,
        )};
  }
`

export const TextGrid = styled(Grid)`
  width: 100%;
  margin: 0;
`

export const TextGridItem = styled(GridItem)<{
  horizontalAlignment?: HorizontalAlignment
}>`
  display: flex;
  flex-direction: column;
  margin: 0;
  ${(props) =>
    props.horizontalAlignment === 'right' &&
    'justify-self: right; text-align: right'}
  ${(props) =>
    props.horizontalAlignment === 'center' &&
    'justify-self: center; text-align: center'}
`
export const ImageItem = styled(GridItem)`
  margin: 0;
  display: inline;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    display: inline;
  }
`
export const ButtonsContainer = styled.div<{
  centerText?: boolean
}>`
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    ${(props) => props.centerText && 'margin: 0 auto'}
  }
`

export const StyledLink = styled.a`
  display: block;
  &:focus-visible {
    outline: ${(props) => props.theme.colors.palette.brand.base} solid 3px;
    outline-offset: -3px;
  }
`

export const StyledButton = styled(Button)`
  height: fit-content;
  margin-bottom: ${spacing(2)};

  &:not(:last-child) {
    margin-right: ${spacing(2)};
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    height: auto;
    margin-bottom: 0;
  }
`
